import { useTranslation } from "react-i18next";
import type { RuntimeObservedState } from "../lib/api";

const TONE: Record<RuntimeObservedState, string> = {
  unknown: "admin__probe",
  pulling: "admin__probe",
  starting: "admin__probe",
  healthy: "admin__probe admin__probe--ok",
  unhealthy: "admin__probe admin__probe--err",
  stopped: "admin__probe",
  failed: "admin__probe admin__probe--err",
};

export function RuntimeStatusBadge(props: { state: RuntimeObservedState }): JSX.Element {
  const { t } = useTranslation();
  return <span className={TONE[props.state]}>{t(`admin.runtime.status.${props.state}`)}</span>;
}
